import { render, staticRenderFns } from "./TruthImageCard.vue?vue&type=template&id=7828988f&scoped=true&"
import script from "./TruthImageCard.vue?vue&type=script&lang=js&"
export * from "./TruthImageCard.vue?vue&type=script&lang=js&"
import style0 from "./TruthImageCard.vue?vue&type=style&index=0&id=7828988f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7828988f",
  null
  
)

export default component.exports